import dayjs from 'dayjs';
import SideSheet from '..';
import { copyToClipboard, formatCoinNetwork, formatToDollar } from '../../../helpers/utils';
import { MdContentCopy } from 'react-icons/md';
import useCustomers from '../../../hooks/useCustomers';
import { FlexDollarTransactionDetailsProps } from '../../../types';
import './FlexDollarTransactionDetails.scss';

const FlexDollarTransactionDetails = ({ show, onClose = () => {}, data }: FlexDollarTransactionDetailsProps) => {
  const { singleCustomer } = useCustomers();

  if (!data) return null;

  const isCredit = Number(data.amount) >= 0;
  const userName = singleCustomer ? `${singleCustomer.firstName} ${singleCustomer.lastName}` : 'N/A';

  return (
    <SideSheet active={show} onClose={onClose} title="Transaction Details">
      <div className="flexdollar-tr-details flex--4">
        <div className="status-section">
          <span className={`status-badge ${isCredit ? 'credit' : 'debit'}`}>{isCredit ? 'Deposit' : 'Withdrawal'}</span>
        </div>

        <div className="flexdollar-tr-details__hero">
          <p className="hero-label">{isCredit ? 'Amount Deposited' : 'Amount Withdrawn'}</p>
          <h1>{formatToDollar(Number(data.amount))}</h1>
        </div>

        <div className="details flex--4">
          <div className="label-cont flex--4">
            <label>Reference</label>
            <div className="copy flex--2" onClick={() => copyToClipboard('Reference', data.transactionId || '')}>
              <p>{data.transactionId || '-----'}</p>
              {data.transactionId && <MdContentCopy className="pointer" />}
            </div>
          </div>

          <div className="label-cont flex--4">
            <label>Date</label>
            <p>{data.date ? dayjs(data.date * 1000).format('D MMM YYYY | h:mm A') : '-----'}</p>
          </div>

          <div className="label-cont flex--4">
            <label>User</label>
            <p>{userName}</p>
          </div>

          <div className="label-cont flex--4">
            <label>Coin and network</label>
            <p>{formatCoinNetwork(data.currency, data.network) || '-----'}</p>
          </div>

          <div className="label-cont flex--4">
            <label>Address</label>
            <div className="copy flex--2" onClick={() => copyToClipboard('Address', data.code || '')}>
              <p>{data.code || '-----'}</p>
              {data.code && <MdContentCopy className="pointer" />}
            </div>
          </div>
        </div>
      </div>
    </SideSheet>
  );
};

export default FlexDollarTransactionDetails;
